import Backbone from 'backbone'
import template from './basics.hbs'
import _ from 'lodash'
import $ from 'jquery'
import nonAbbreviatedValuesTooltip from 'scoreboard/components/non-abbreviated-values-tooltip.hbs'
import TooltipAndDetails from 'scoreboard/components/tooltip-and-details'
import Tooltip from 'scoreboard/components/tooltip'
import HistoryInfo from 'scoreboard/components/history-info'
import appDisplay from 'scoreboard/components/app-display'
import LineClamp from 'scoreboard/components/line-clamp'
import { isV5 } from 'scoreboard/components/version'

var Basics = Backbone.View.extend({

	// this.model is the Initiative
	className: 'panel',

	events: {
		'click .budget-warning': 'history',
		'mouseenter .basics-info .budget-warning svg': 'showBudgetWarning',
		'mouseenter .basics-details .budget-warning svg': 'showBudgetWarning',
		'mouseleave .budget-warning svg': 'removeBudgetWarnings'
	},

	/**
	 * options.model is the Initiative
	 * options.fullContext is populated from model.context()
	 */
	initialize: function(options) {
		this.options = options || {}
		// note other stuff could change, but only on the edit tab and we
		// re-render the whole screen anyway when switching tabs
		this.model.on('change:budgetRemaining', this.render.bind(this))
	},

	render: function() {
		var context = this.context()
		this.$el.empty().append(template(context))
		this._setupTooltipAndDetails()

		if (isV5()) {
			if (!_.isEmpty(context.description)) {
				this._setupDescriptionLineClamp()
			}
		}
		return this
	},

	_setupTooltipAndDetails: function() {
		this.nonAbbreviatedTooltips = new TooltipAndDetails({
			el: this.el,
			selector: '[data-unshortened-value]',
			tooltipContent: e => nonAbbreviatedValuesTooltip({
				header: e.target.dataset.unshortenedHeader,
				value: e.target.dataset.unshortenedValue
			}),
			tooltipOptions: {
				extraClass: 'tooltip-and-details non-abbreviated-tooltip initiatives-overview-basics-non-abbreviated-tooltip',
				placement: 'above'
			}
		})
	},

	// TODO: Remove when V5 is no longer supported
	_setupDescriptionLineClamp: function() {
		this.descriptionLineClamp = new LineClamp({
			el: this.$('.description'),
			maxHeight: 80 // 80 matches height from basics.scss:.has-text-overflow
		})
		this.on('resize', () => this.descriptionLineClamp.resize())
		this.descriptionLineClamp.resize()
	},

	_createWarningTooltip: function(attachTo, content) {
		return new Tooltip({
			extraClass: 'basics-warning-tooltip',
			attachTo,
			content,
			placement: 'above',
			arrow: 'center'
		}).render()
	},

	showBudgetWarning: function(e) {
		var target = $(e.target)
		this.budgetWarningTooltip = this._createWarningTooltip(
			target,
			target.closest('span').data('warning')
		)
	},

	removeBudgetWarnings: function() {
		this.budgetWarningTooltip && this.budgetWarningTooltip.remove()
	},

	context: function() {

		var ctx = this.options.fullContext

		var data = _.cloneDeep(this.model.attributes)
		data.description = ctx.description
		data.startDate = ctx.value('initiatives.startDate')
		data.endDate = ctx.value('initiatives.endDate')
		data.totalBudget = ctx.value('initiatives.budget')
		data.totalBudgetUnshortened = ctx.value('initiatives.budgetUnshortened')
		data.budgetRemaining = ctx.value('initiatives.budgetRemaining')
		data.budgetRemainingUnshortened = ctx.value('initiatives.budgetRemainingUnshortened')
		data.list = _.map(ctx.pick(['initiatives.startDate',
							  'initiatives.dueDate',
							  'initiatives.completionDate',
							  'initiatives.percentTimeElapsed']), obj => {
			let item = _.pick(obj, 'key', 'value')
			if (item.key === 'initiatives.dueDate') {
				item.warning = ctx.endDateWarning
			} else if (item.key === 'initiatives.startDate') {
				item.warning = ctx.startDateWarning
			}

			return item
		})
		data.basicDetails = data.list.length > 0
		data.budgetWarning = ctx.budgetWarning
		return data
	},

	history() {
		const {label, history} = this.options.fullContext
		appDisplay.dialog(new HistoryInfo({model: this.model, label, history, full: true}))
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.nonAbbreviatedTooltips, this.budgetWarningTooltip], 'remove')
	}

})

export default Basics

Basics.__filename__ = 'initiatives/overview/basics.js'
